export const getCampaignsListNextjsUrl = () => '/campaigns'
